import * as React from 'react';
import { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import styles from './ClientAgreement.module.css';
import logo from './icon.png';
import AgreementPage1 from './AgreementPage1/AgreementPage1';
import AgreementPage2 from './AgreementPage2/AgreementPage2';
import { InjectedFormProps } from 'redux-form';
import LeftArrowIcon from '@material-ui/icons/ArrowBack';
import AgreementPage3 from './AgreementPage3/AgreementPage3';
import AgreementPage4 from './AgreementPage4/AgreementPage4';
import AgreementPage5 from './AgreementPage5/AgreementPage5';
import AgreementPage6 from './AgreementPage6/AgreementPage6';
import AgreementPage7 from './AgreementPage7/AgreementPage7';
import AgreementPage8 from './AgreementPage8/AgreementPage8';
import AgreementPage9 from './AgreementPage9/AgreementPage9';
import AgreementPage10 from './AgreementPage10/AgreementPage10';
import AgreementPage11 from './AgreementPage11/AgreementPage11';
import AgreementPage12 from './AgreementPage12/AgreementPage12';
import ContentContainer from './ContentContainer/Content';
import Button from '@material-ui/core/Button/Button';
import { scroller } from 'react-scroll';

interface ClientAgreementProps {
  isMobile?: boolean;
  submittingAgreement: boolean;
  initialAgreementPage: number;
  initialAgreementValues: any;
  saveOrSubmit: (currentPage: number, submitted?: boolean) => void;
}

const ClientAgreement = ({
  isMobile,
  saveOrSubmit,
  submittingAgreement,
  initialAgreementPage,
  initialAgreementValues
}: ClientAgreementProps) => {
  const [page, setPage] = useState(initialAgreementPage);
  useEffect(() => setPage(initialAgreementPage), [initialAgreementPage]);

  const agreementPageProps = {
    isMobile,
    initialValues: initialAgreementPage === page ? initialAgreementValues : {},
    onSubmit: () => setPage(page + 1),
    onSubmitFail: (err: any) => {
      scroller.scrollTo(Object.keys(err)[0], {
        containerId: `content-container-${page}`,
        offset: -75
      });
      window.scrollTo(0, 0);
    },
    saveOrSubmit,
    submittingAgreement
  };
  return (
    <Grid container justify="center">
      <Grid item xs={12} sm={10} md={8} container direction="column" className={styles.container}>
        <div className={styles.spacer} />
        <Grid container>
          <Grid item xs={1}>
            {page !== 1 && (
              <Button
                variant="outlined"
                onClick={() => setPage(page - 1)}
                className={styles.backButton}>
                <LeftArrowIcon className={styles.backIcon} />
              </Button>
            )}
          </Grid>
          <Grid
            item
            xs={10}
            container
            direction="column"
            alignItems="center"
            className={styles.logoContainer}>
            <img src={logo} width={50} height={50} alt="Ascend logo" />
            <Typography variant="subheading">
              <span className={styles.logoSubHeading}>Ascend Client Services Agreement</span>
            </Typography>
          </Grid>
        </Grid>
        {page === 1 && <AgreementPage1 {...agreementPageProps} />}
        {page === 2 && <AgreementPage2 {...agreementPageProps} />}
        {page === 3 && <AgreementPage3 {...agreementPageProps} />}
        {page === 4 && <AgreementPage4 {...agreementPageProps} />}
        {page === 5 && <AgreementPage5 {...agreementPageProps} />}
        {page === 6 && <AgreementPage6 {...agreementPageProps} />}
        {page === 7 && <AgreementPage7 {...agreementPageProps} />}
        {page === 8 && <AgreementPage8 {...agreementPageProps} />}
        {page === 9 && <AgreementPage9 {...agreementPageProps} />}
        {page === 10 && <AgreementPage10 {...agreementPageProps} />}
        {page === 11 && <AgreementPage11 {...agreementPageProps} />}
        {page === 12 && <AgreementPage12 {...agreementPageProps} />}
        {page === 13 && (
          <ContentContainer
            isMobile={isMobile}
            requiredSignatures="none"
            saveOrSubmit={saveOrSubmit}
            finalReview
            submittingAgreement={submittingAgreement}
            currentPage={13}>
            <div className={styles.reviewMainHeader}>
              Please confirm your information is correct
              <br />
              <br />
            </div>
            <AgreementPage1 {...agreementPageProps} review reviewHeader="Initial Information" />
            <AgreementPage4 {...agreementPageProps} review reviewHeader="Debts" />
            <AgreementPage7 {...agreementPageProps} review reviewHeader="Program Details" />
            <AgreementPage8 {...agreementPageProps} review reviewHeader="Finxera/CFT Part 1" />
            <AgreementPage9 {...agreementPageProps} review reviewHeader="Finxera/CFT Part 2" />
          </ContentContainer>
        )}
      </Grid>
    </Grid>
  );
};

export interface AgreementPageProps {
  saveOrSubmit: (currentPage: number, submitted?: boolean) => void;
  name: string;
  address: string;
  clientState: string;
  advisorName?: string;
  existingSignature?: string;
  residence?: string;
  draftOption?: string;
  isMobile?: boolean;
  submittingAgreement: boolean;
  onEdit?: () => void;
  review?: boolean;
  calculatedPayoff: string;
  draftAmount: string;
  totalDebt: number;
  estimatedSettlementAmount: number;
  estimatedProgramFee: number;
  estimatedProgramFeePercent: string;
  estimatedProgramLength: string;
  programLengthPayments: number;
  estimatedProgramSavings: number;
}

export type AgreementPageWithFormProps = AgreementPageProps & InjectedFormProps;

export default ClientAgreement;
